import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/unauthenticated',
    name: 'UnauthenticatedView',
    component: () => import('@/views/UnauthenticatedView.vue'),
    meta: {
      layout: 'LayoutDefault',
      requiresAuth: false,
    },
  },
];
export default routes;
